import type { AnswerResult, AppConfig, CommonsStats, EmotionLabel, TrialStimulus } from '../types';

async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, {
    ...init,
    headers: {
      'content-type': 'application/json',
      ...(init?.headers || {})
    }
  });
  const data: any = await response.json().catch(() => ({}));
  if (!response.ok || data?.ok === false) {
    throw new Error(data?.error || `Request failed: ${response.status}`);
  }
  return data as T;
}

export async function fetchConfig(): Promise<AppConfig> {
  return api<AppConfig>('/api/config');
}

export async function createSession(payload: { deviceKey: string; consentVersion: string; turnstileToken?: string }) {
  return api<{ ok: true; deviceHashPreview: string; humanVerifiedHours: number }>('/api/session', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export async function fetchTrial(deviceKey: string): Promise<TrialStimulus> {
  const data = await api<{ ok: true; stimulus: TrialStimulus }>('/api/trial', {
    method: 'POST',
    body: JSON.stringify({ deviceKey })
  });
  return data.stimulus;
}

export async function submitAnswer(payload: {
  deviceKey: string;
  stimulusId: string;
  guessedLabel: EmotionLabel;
  guessedValence: number;
  guessedArousal: number;
  confidence: number;
  responseMs: number;
}): Promise<AnswerResult> {
  return api<AnswerResult>('/api/answer', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export async function fetchStats(): Promise<CommonsStats> {
  return api<CommonsStats>('/api/stats');
}
